module.exports = __webpack_public_path__ + "static/logo-lepri-0e1bc36d3589dc73d0e6e7feadb5bb4c.jpeg";